// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"_f267b4f","eventDetails":"_5c4706c","dateTimeContainer":"_c290076","clockIcon":"_c94dbe4","participants":"_a316513","flameWrapper":"_40a4996"};